<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="操作日志">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">用户</span>
                            <div class="input-condition">
                                <admin-auto-complete v-model="condition.operator_id" :factor-id="1"></admin-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">操作对象</span>
                            <div class="input-condition">
                                <el-select v-model="condition.model" placeholder="请选择操作对象">
                                    <el-option v-for="item in models" :key="item.key" :label="item.name" :value="item.key"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">动作</span>
                            <div class="input-condition">
                                <el-select v-model="condition.action" placeholder="请选择操作动作">
                                    <el-option v-for="item in actions" :key="item.key" :label="item.name" :value="item.key"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="用户姓名" prop="operator" width="120px"></el-table-column>
                    <el-table-column  label="用户名" prop="operator_account" width="120px"></el-table-column>
                    <el-table-column  label="动作" prop="action_name" width="80px"></el-table-column>
                    <el-table-column  label="操作对象" prop="model_name" width="100px"></el-table-column>
                    <el-table-column  label="URL" prop="url"></el-table-column>
                    <el-table-column  label="IP" prop="ip" width="120px"></el-table-column>
                    <el-table-column  label="操作时间" prop="created_at_str" width="180px"></el-table-column>

                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page" :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { getLogs, getLogModel, getLogAction } from '@/service/user'
    import { parseTime } from '@/utils'
    import AdminAutoComplete from "../../../components/auto-complete/admin-auto-complete";
    export default {
        name: "List",
        components: {
            AdminAutoComplete
        },
        data () {
            return {
                list: [],
                condition : {
                    operator_id : null,
                    model : '',
                    action : '',
                    total : 0,
                    page : 1,
                    per_page : 10,
                },
                actions : [],
                models : [],
                isLoading: false
            }
        },
        mounted () {
            this.mountedFunc()
        },
        methods: {
            async mountedFunc() {
                await getLogModel().then((data) => {
                    for (let i in data) {
                        let row = data[i]
                        this.models.push({
                            key : i,
                            name : row,
                        })
                    }
                })
                await getLogAction().then((data) => {
                    for (let i in data) {
                        let row = data[i]
                        this.actions.push({
                            key : row.type,
                            name : row.desc,
                        })
                    }
                })
                this.initData()
            },
            handleSearch() {
                this.condition.page = 1
                this.initData()
            },
            resetSearch() {
                this.condition = {
                    operator_id : null,
                    model : '',
                    action : '',
                    page : 1,
                    total : 0,
                    per_page : 10,
                }
                this.initData()
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = []
                let query = {
                    page : this.condition.page,
                    per_page : this.condition.per_page,
                    operator_id : this.condition.operator_id,
                    model : this.condition.model,
                    action : this.condition.action,
                }
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                // 模拟fetch请求数据....
                await getLogs(query).then((data) => {
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        if (row.created_at)  {
                            row.created_at_str = parseTime(new Date(row.created_at))
                        } else {
                            row.created_at_str = ''
                        }
                        let action = this.actions.filter(item => {
                            if (item.key == row.action) return item
                        })
                        row.action_name = action.length > 0 ? action[0].name : ''
                        let model = this.models.filter(item => {
                            if (item.key == row.model) return item
                        })
                        row.model_name = model.length > 0 ? model[0].name : ''
                    }
                    this.list = listData

                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },
        }
    }
</script>

<style scoped>

</style>
